module.exports = __webpack_public_path__ + "static/media/close.cf8ad111.svg";